import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=499b2f94&scoped=true&lang=pug&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio.styl?vue&type=style&index=0&id=499b2f94&lang=stylus&scoped=true&"
import style1 from "./Portfolio.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b2f94",
  null
  
)

export default component.exports